import { RequireSFDCAuth } from "@client-shared/providers/auth";
import { Route, Routes } from "react-router-dom";
import AuthRoutes from "./components/Auth";
import "./lib/i18n";
import {
  AnalyticsPage,
  CustomersPage,
  DashboardPage,
  FinanceDashboardPage,
  FinanceInvoicesPage,
  FinanceSettingsPage,
  HomePage,
  InventoryPage,
  LabelsPage,
  NotificationsPage,
  OnboardingMapProductsPage,
  OnboardingPage,
  OnboardingSuccessPage,
  OrdersPage,
  PreferencesPage,
  ProductsPage,
  SearchPage,
} from "./routes";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Routes>
        <Route path="/oauth/*" element={<AuthRoutes />} />
        <Route element={<RequireSFDCAuth />}>
          {/* Home */}
          <Route path="/" element={<HomePage />} />

          {/* Dashboard */}
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Products */}
          <Route path="/products" element={<ProductsPage />} />

          {/* Orders */}
          <Route path="/orders" element={<OrdersPage />} />

          {/* Analytics */}
          <Route path="/analytics" element={<AnalyticsPage />} />

          {/* Customers */}
          <Route path="/customers" element={<CustomersPage />} />

          {/* Inventory */}
          <Route path="/inventory" element={<InventoryPage />} />

          {/* Labels */}
          <Route path="/labels" element={<LabelsPage />} />

          {/* Notifications */}
          <Route path="/notifications" element={<NotificationsPage />} />

          {/* Preferences */}
          <Route path="/preferences" element={<PreferencesPage />} />

          {/* Search */}
          <Route path="/search" element={<SearchPage />} />

          {/* Finance routes */}
          <Route path="/finance" element={<FinanceDashboardPage />} />
          <Route path="/finance/invoices" element={<FinanceInvoicesPage />} />
          <Route path="/finance/settings" element={<FinanceSettingsPage />} />

          {/* Onboarding routes */}
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route
            path="/onboarding/map-products"
            element={<OnboardingMapProductsPage />}
          />
          <Route
            path="/onboarding/success"
            element={<OnboardingSuccessPage />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
